$(document).ready(function () {
  $(document).click(function (event) {
    $(
      ".product-form__error-message-wrapper.product-form__main-error-message"
    ).hide();
    $(
      ".product-form__error-message-wrapper.product-form__sticky-error-message"
    ).hide();
  });
  $("digitalgift").click(function () {
    $("#cartpopupboxnav").removeClass("activenav loader_active");
    $("html").removeClass("cart-open");
  });
  // apple watch js

  // ends
  window.theme = window.theme || {};
  $(".size_help").click(function () {
    $(".size_help-popup").addClass("open");
    $(".size_help-popup").css("display", "flex");
    $("html").addClass("no-scroll");
  });

  $(
    ".size_help-close, .size_help_mask, .preorder-popup_mask, .size_help-btn"
  ).click(function (e) {
    e.preventDefault();
    $(".size_help-popup").removeClass("open");
    $("html").removeClass("no-scroll");
  });
  $.getJSON("https://api.db-ip.com/v2/free/self", function (data) {
    if (data.countryCode == "US") {
      $(".cart-status.cart-afterpay").removeClass("hide");
    }
  });

  $(".afterpay .afterpay-svg, .cart-status.cart-afterpay p").click(function () {
    $(".afterpay-popup").addClass("open");
    $("html").addClass("no-scroll");
  });

  $(".afterpay-close, .preorder-popup_mask").click(function () {
    $(".afterpay-popup").removeClass("open");
    $("html").removeClass("no-scroll");
  });

  $(".empty-cart-only").hide();
  //////////////////// cart drawer custom js
  // dom update cart
  // updateCart();

  // ends

  /* ===================================================================================
     === MERGED FROM JOSH (old pyscart.js, lines 54-62 & 130-565) — "Little Luxuries"    
     === glass charm-grid upsell engine. Added additively; nothing from the Latest file  
     === was removed. DORMANT until Josh's cartdrawer.liquid markup ([data-upsell] /      
     === .cart-charm) is merged and updateCart() is wired to call mdsUpsellSync().        
     === All bindings below are guarded by element presence / delegated on selectors that 
     === do not exist in the current cart, so this block is inert and safe as-is.         
     =================================================================================== */
  // computed ++undefined = NaN, and the staleness guard (NaN !== 0) then DISCARDED the initial
  // page-load paint — the root cause of the cart opening "empty" after a refresh.
  // mdsCartSeq: newest requested /cart.js refresh — only its response may paint.
  // mdsCartPainted: true once any response has painted (before that, cart state is unconfirmed).
  var mdsCartSeq = 0;
  var mdsCartPainted = false;

  // Cache product JSON so cart refreshes do not refetch the same product.
  var mdsProductJsonCache = {};

  function mdsGetProductJson(productUrl) {
    if (!productUrl) {
      return Promise.reject(new Error("Missing product URL"));
    }

    if (mdsProductJsonCache[productUrl]) {
      return mdsProductJsonCache[productUrl];
    }

    mdsProductJsonCache[productUrl] = $.ajax({
      url: productUrl + ".js",
      dataType: "json",
      timeout: 4000
    }).catch(function (err) {
      // Remove failed request from cache so a later refresh can retry.
      delete mdsProductJsonCache[productUrl];
      throw err;
    });

    return mdsProductJsonCache[productUrl];
  }
  var mdsUpsellAutoOpenPending = false;
  var mdsUpsellAutoActionTimer = null;
  var mdsUpsellInitialStateApplied = false;
  var mdsUpsellCurrentProductCount = 0; // Number of actual cart lines/products.

  function mdsMarkCartAddPending() {
    mdsUpsellAutoOpenPending = true;
  }
  updateCart();

  // ends

  $(document).on("click", "#cartopennav, #cartopennavmov", function (e) {
    e.preventDefault();
    $("[data-upsell] .cart-upsell__grid").removeClass("is-filtered"); // fresh open → entry stagger plays
    // Empty vs not: trust only CONFIRMED signals. html.cart-has-items comes from a real
    // /cart.js response; the badge is read from BOTH triggers (header1's only badge lives in
    // #cartopennavmov — the old #cartopennav-scoped read matched nothing → NaN → wrong empty
    // paint). The DESTRUCTIVE empty paint (it wipes the item list) is allowed only after a
    // response has confirmed the cart state; before that the drawer opens on the (correct)
    // server-rendered markup and updateCart paints the truth when it lands.
    var badgeCount = parseInt(
      $("#cartopennav .btn-cart-trigger__count, #cartopennavmov .btn-cart-trigger__count")
        .first()
        .text(),
      10
    );
    var cartHasItems =
      document.documentElement.classList.contains("cart-has-items") || badgeCount > 0;
    if (cartHasItems) {
      $("html").addClass("cart-open");
      $("#cartpopupboxnav").addClass("activenav");
      // Paint the non-empty state EXPLICITLY — the empty block may have been shown by a
      // previous empty-paint and nothing else hides it here.
      $(".header-cart__progg").hide();
      $(".emptycart__contents").hide();
      $(".content-cart-nav").show();
      $(".cart-footer-nav").show();
      $(".content-cart-nav .not-empty-cart").show();
      $("#cartpopupboxnav").removeClass("loader_active");
    } else if (mdsCartPainted) {
      // A /cart.js response has confirmed the cart is empty — safe to paint the empty state.
      $("#cartpopupboxnav").addClass("activenav");
      $("html").addClass("cart-open");
      $(".header-cart__progg").show();
      $(".emptycart__contents").show();
      $(".content-cart-nav").show();
      $("#cart_container_id").empty();
      $(".cart-footer-nav").hide();
      $(".gift_product").hide();
      $(".upsellempy").hide();
      $(".cart_gift_box").addClass("hide");
      $(".content-cart-nav .not-empty-cart").hide();
      $("#cartpopupboxnav").removeClass("loader_active");
      $(".cart__matching").hide();
    } else {
      // No response yet (fast open after a refresh) — open on the server-rendered state,
      // touch nothing, and fetch the truth.
      $("html").addClass("cart-open");
      $("#cartpopupboxnav").addClass("activenav");
      $("#cartpopupboxnav").removeClass("loader_active");
      updateCart();
    }
    var currentCartCount = mdsUpsellCurrentProductCount;

    if (
      window.matchMedia("(max-width: 991px)").matches &&
      currentCartCount > 1
    ) {
      if (window.mdsUpsellAutoCollapse) {
        window.mdsUpsellAutoCollapse();
      }
    } else {
      // One product regardless of quantity:
      // allow Little Luxuries to remain/open.
      mdsUpsellUserCollapsed = false;
      mdsUpsellSync();
    }
  });



  function mdsCloseCart() {
    var cart = document.getElementById("cartpopupboxnav");
    if (!cart || !cart.classList.contains("activenav")) return;
    var node = document.querySelector("[data-upsell]");
    if (node && node.classList.contains("is-closing")) return; // already closing
    var closeDrawer = function () {
      $("#cartpopupboxnav").removeClass("activenav loader_active");
      $("html").removeClass("cart-open");
      if (node) node.classList.remove("is-closing");
    };
    // Reverse of the entry (which is cart-in THEN upsell-out): on close the upsell flyout slides
    // out + tiles reverse-stagger FIRST, then the cart closes ~320ms later. Desktop only — on
    // mobile the upsell is inline in the cart, so it just closes with the drawer.
    var desktop = window.matchMedia("(min-width: 992px)").matches;
    if (
      desktop &&
      node &&
      !node.classList.contains("hide") &&
      node.querySelector(".cart-charm")
    ) {
      node.classList.add("is-closing");
      setTimeout(closeDrawer, 320); // mirrors the entry's ~0.32s cart→upsell gap, reversed
    } else {
      closeDrawer();
    }
  }
  $(
    ".modal-header-nav .close, .modal-header-nav .cart-close-mobile-btn, .menu-mask"
  ).on("click", mdsCloseCart);

  /* ── Little Luxuries upsell (glass charm grid) ──────────────────────────────────
     Homes the single upsell node (desktop flyout beside the cart, or inline within it on
     mobile), hides it when there are no matching products, and records the tile count for the
     reverse-close stagger. The show/hide REVEAL is CSS-driven off html.cart-open (see the
     stylesheet in cart-drawer.liquid). Idempotent — safe to call on open/resize/render. */
  // Set when the shopper deliberately collapses the drawer (header tap / swipe-down): the
  // adaptive peek then stays out of the way until the cart is next opened, however much room
  // frees up. Cleared on cart open so a fresh visit re-evaluates the space.
  var mdsUpsellUserCollapsed = false;
  // Track the previous cart item count so Little Luxuries can react
  // correctly when cart items are added/removed.
  var mdsUpsellLastCartItemCount = null;
  window.mdsUpsellSync = function () {
    var node = document.querySelector("[data-upsell]");
    if (!node) return;
    var flyout = document.querySelector("[data-upsell-flyout]");
    var inline = document.querySelector("[data-upsell-inline]");
    var slider = node.querySelector(".cart-matching-slider");
    var tiles = slider ? slider.querySelectorAll(".cart-charm") : [];
    var desktop = window.matchMedia("(min-width: 992px)").matches;
    var host = desktop ? flyout : inline;
    // Home the single grid node: desktop flyout beside the cart, or inline within it on mobile.
    if (host && node.parentElement !== host) host.appendChild(node);
    // Charms that entered the cart OUTSIDE the upsell are excluded from the grid (CSS hides
    // .is-incart-external), so the drawer only stays up while it has tiles to show.
    var remaining = 0;
    tiles.forEach(function (t) {
      if (!t.classList.contains("is-incart-external")) remaining++;
    });
    node.classList.toggle("hide", remaining === 0);
    node.style.setProperty("--n", tiles.length); // tile count → drives the reverse-close stagger
    // Mobile: dock + adaptive peek. Measured on the NEXT FRAME so the DOM is final (updateCart
    // rebuilds the item rows AFTER calling into here — measuring now would see stale rows).
    if (!desktop && inline) {
      if (mdsUpsellRaf) cancelAnimationFrame(mdsUpsellRaf);
      mdsUpsellRaf = requestAnimationFrame(mdsUpsellMeasure);
    }
  }

  /* One rule, three measurements — no magic constants, no timers:
       footTop     = where the footer starts (viewport rect — exact, whatever its height/margins)
       contentEnd  = bottom of the LAST VISIBLE block in the cart body (skips hidden sections)
       needed      = header + one tile row + 20% of the next + breathing room
     The bar always docks at footTop (--cart-foot-h). The peek shows only if it FITS in the free
     gap AND the shopper hasn't deliberately collapsed it this cart-session. */
  var mdsUpsellRaf = null;
  window.mdsUpsellMeasure = function () {
  mdsUpsellRaf = null;

  var node = document.querySelector("[data-upsell]");
  var inline = document.querySelector("[data-upsell-inline]");
  var upsellBody = node && node.querySelector(".cart-upsell__body");

  if (!node || !inline || !upsellBody) return;

  var foot = document.querySelector("#cartpopupboxnav .cart-footer-nav");
  var fr = foot && foot.offsetHeight
    ? foot.getBoundingClientRect()
    : null;

  if (!fr) return;

  /*
   * Keep the Little Luxuries bar docked above the cart footer.
   */
  inline.style.setProperty(
    "--cart-foot-h",
    Math.max(0, Math.round(window.innerHeight - fr.top)) + "px"
  );

  /*
   * IMPORTANT:
   * Do NOT use tile.offsetHeight here.
   *
   * The upsell body is collapsed when this function runs, therefore
   * its children can have offsetHeight === 0.
   *
   * We only need to know whether there are available charm tiles.
   */
  var visibleTile = null;

  var allTiles = node.querySelectorAll(
    ".cart-charm:not(.is-incart-external)"
  );

  for (var ti = 0; ti < allTiles.length; ti++) {
    if (
      allTiles[ti].style.display !== "none" &&
      !allTiles[ti].classList.contains("is-incart-external")
    ) {
      visibleTile = allTiles[ti];
      break;
    }
  }

  /*
   * Mobile peek height.
   *
   * 110px gives enough room for the Little Luxuries heading
   * and the first product row.
   */
  var peekPx = 0;

  if (
    !mdsUpsellUserCollapsed &&
    visibleTile &&
    !node.classList.contains("hide")
  ) {
    peekPx = 220;
  }

  /*
   * Apply the peek directly to the BODY.
   */
  upsellBody.style.setProperty(
    "--cu-peek",
    peekPx + "px"
  );

  /*
   * This class changes:
   *
   * + ADD CHARMS
   *        ↓
   * peek / expand affordance
   */
  node.classList.toggle(
    "has-peek",
    peekPx > 0
  );

  mdsUpsellFade();
}

  // Toggle the grid's "more to scroll" fade: bottom fade on the (vertical) desktop grid, right-edge
  // fade on the (horizontal) mobile drawer grid. Cleared once scrolled to the end of either axis.
  function mdsUpsellFade() {
    var g = document.querySelector("[data-upsell] .cart-upsell__grid");
    if (!g) return;
    var moreDown = g.scrollHeight - g.clientHeight - g.scrollTop > 2;
    var moreRight = g.scrollWidth - g.clientWidth - g.scrollLeft > 2;
    g.classList.toggle("has-more", moreDown || moreRight);
  }

  /* ── Mobile drawer: grab-and-swipe sheet (ported from the bag customizer's charm tray). ──
     --cu-expand (0→1) drives the body height in CSS; a swipe on the peek interpolates it in
     real time and snaps on release (flick commits instantly); fully open, the grid is a native
     scroller and a swipe down at its top collapses the sheet. Tap still toggles. */
  (function () {
    var node = document.querySelector("[data-upsell]");
    var body = node && node.querySelector(".cart-upsell__body");
    if (!node || !body) return;
    var grid = body.querySelector(".cart-upsell__grid");
    var mqMobile = window.matchMedia("(max-width: 991px)");

    function cuFrac() {
      return parseFloat(node.style.getPropertyValue("--cu-expand")) || 0;
    }
    function setCU(f) {
      f = f < 0 ? 0 : f > 1 ? 1 : f;
      node.style.setProperty("--cu-expand", f);
      node.classList.toggle("is-open", f > 0.5);

      if (f === 0 && grid) grid.scrollTop = 0;

      var head = node.querySelector("[data-upsell-toggle]");
      if (head) {
        head.setAttribute(
          "aria-expanded",
          f > 0.5 ? "true" : "false"
        );
      }
    }

    window.mdsUpsellAutoCollapse = function () {
      if (!mqMobile.matches) return;
      mdsUpsellUserCollapsed = true;

      setCU(0);

      requestAnimationFrame(function () {
        mdsUpsellMeasure();
      });
    };

    // automatically open little-luxury when item added to cart
    window.mdsUpsellAutoOpen = function () {
      if (!mqMobile.matches) return;

      var cartCount = mdsUpsellCurrentProductCount;

      if (cartCount > 1) {
        if (window.mdsUpsellAutoCollapse) {
          window.mdsUpsellAutoCollapse();
        }

        return;
      }

      mdsUpsellUserCollapsed = false;
      mdsUpsellSync();

      requestAnimationFrame(function () {
        if (node.classList.contains("hide")) {
          return;
        }

        setCU(0);

        requestAnimationFrame(function () {
          mdsUpsellMeasure();
        });
      });
    }; // <-- THIS WAS MISSING

    function cuOpenIntoView() {
      setTimeout(mdsUpsellFade, 530);
    }

    // Header row tap toggles; a tap on the peek (tiles are pointer-events:none there) opens.
    // A DELIBERATE close also dismisses the peek for the rest of this cart-session.
    $(document).on("click", "[data-upsell-toggle]", function () {
      var opening = !node.classList.contains("is-open");
      if (!opening) mdsUpsellUserCollapsed = true;
      setCU(opening ? 1 : 0);
      mdsUpsellSync();
      if (opening) cuOpenIntoView();
      else setTimeout(mdsUpsellFade, 520);
    });
    $(body).on("click", function () {
      if (!mqMobile.matches || node.classList.contains("is-open")) return;
      setCU(1);
      cuOpenIntoView();
    });

    /* px the sheet travels from peek (110) to open (56dvh) — visual viewport so the finger maps
       1:1 to what the CSS calc renders. */
    function dragRange() {
      var vh = (window.visualViewport && window.visualViewport.height) || window.innerHeight;
      return Math.max(1, vh * 0.56 - 110);
    }
    var tMode = "", tStartY = 0, tLastY = 0, tVel = 0, tStartF = 0, tBlockClick = false;
    // A swipe that began on the body must not also fire the tap-open / a tile add — swallow the
    // trailing click (capture phase); a fresh touch clears the flag so deliberate taps still work.
    body.addEventListener(
      "click",
      function (ev) {
        if (!tBlockClick) return;
        tBlockClick = false;
        ev.stopPropagation();
        ev.preventDefault();
      },
      true
    );
    body.addEventListener(
      "touchstart",
      function (e) {
        tBlockClick = false;
        if (!mqMobile.matches) { tMode = "scroll"; return; }
        if (e.touches.length !== 1) { if (tMode === "") tMode = "scroll"; return; }
        tStartY = tLastY = e.touches[0].clientY;
        tVel = 0;
        tMode = ""; // decided on the first real move
      },
      { passive: true }
    );
    body.addEventListener(
      "touchmove",
      function (e) {
        var t = e.touches[0];
        if (!t) return;
        var y = t.clientY;
        if (tMode === "") {
          var total = tStartY - y; // up = positive
          if (Math.abs(total) < 3) return;
          if (!node.classList.contains("is-open")) tMode = "sheet";              // peek → swipe drives the sheet
          else if (grid && grid.scrollTop <= 0 && total < 0) tMode = "sheet";    // open + at top + down → collapse
          else { tMode = "scroll"; return; }                                     // open → native grid scroll
          node.classList.add("is-dragging");
          tLastY = y;
          tStartF = cuFrac();
        }
        if (tMode === "sheet") {
          var dy = tLastY - y; // incremental; up = grow
          tLastY = y;
          tVel = tVel * 0.7 + dy * 0.3; // smoothed flick velocity
          setCU(cuFrac() + dy / dragRange());
          if (e.cancelable) e.preventDefault(); // take the gesture from native scroll
        }
      },
      { passive: false }
    );
    var endTouch = function () {
      node.classList.remove("is-dragging");
      if (tMode === "sheet") {
        /* Sensitive snap (same thresholds as the customizer): a flick commits either way; a slow
           drag opens after ~25% and closes once below ~75%. */
        var f = cuFrac(), snap;
        if (tVel > 0.7) snap = 1;
        else if (tVel < -0.7) snap = 0;
        else if (f > tStartF) snap = f >= 0.25 ? 1 : 0;
        else snap = f >= 0.75 ? 1 : 0;
        // Deliberate dismiss = closing from OPEN, or a clear downward swipe on the peek.
        // (A failed up-swipe that snaps back must NOT dismiss the peek.)
        if (snap === 0 && (tStartF >= 0.5 || tVel < -0.05)) mdsUpsellUserCollapsed = true;
        setCU(snap);
        mdsUpsellSync();
        tBlockClick = true; // a sheet drag emits a trailing click — swallow it
        if (snap === 1) cuOpenIntoView();
        else setTimeout(mdsUpsellFade, 520);
      }
      tMode = "";
    };
    body.addEventListener("touchend", endTouch);
    body.addEventListener("touchcancel", endTouch);
  })();

  // One cart-item skeleton row (reuses the cart's own skeleton design) shown in the item
  // list while an add is in flight, then swapped for the real line by updateCart().
  function mdsCartSkeletonRow() {
    return (
      '<div class="item-cart-fill-main0 cart_items_div mds-upsell-skeleton">' +
      '<div class="skeleton_card"><div class="skeleton_card_inner">' +
      '<div class="img skeleton_bg"></div>' +
      '<div class="skeleton_content"><div>' +
      '<div class="c_s_heading skeleton_bg"></div>' +
      '<p class="skeleton_bg"></p>' +
      '<div class="c_s_close skeleton_bg"></div></div>' +
      '<div class="skeleton_bottom">' +
      '<div class="c_s_quntity skeleton_bg"></div>' +
      '<div class="c_s_price skeleton_bg"></div></div>' +
      '</div></div></div></div>'
    );
  }

  // Variant ids the shopper added FROM the upsell drawer (session-scoped, survives reloads).
  // Their tiles stay visible as ADDED for feedback; charms that entered the cart any OTHER way
  // (PDP, customizer, ...) are excluded from the grid — nothing useful to do with them here.
  // Pruned in getMatchingItems when the item leaves the cart.
  function mdsUpsellAddedIds() {
    try {
      return new Set(JSON.parse(sessionStorage.getItem("mds-upsell-added") || "[]"));
    } catch (err) {
      return new Set();
    }
  }
  function mdsUpsellSaveAddedIds(set) {
    try {
      sessionStorage.setItem("mds-upsell-added", JSON.stringify(Array.from(set)));
    } catch (err) {}
  }

  // Serialization state for the upsell's cart writes (see the click handler below): requests are
  // chained one-at-a-time; vids with a write still queued keep their optimistic tile state
  // (getMatchingItems skips them) so intermediate repaints can't undo them.
  var mdsUpsellChain = $.Deferred().resolve().promise();
  var mdsUpsellInFlight = new Map(); // vid → "add" | "remove"

  // Placeholder rows for QUEUED adds live in a SIBLING of the item list, so updateCart's
  // rebuilds (which empty the list) never wipe them mid-burst. One placeholder leaves as each
  // write lands — its real row arrives with that write's own refresh, giving the staggered
  // "items landing one by one" feel.
  function mdsPendingSlots() {
    var el = document.getElementById("mds-pending-slots");
    if (!el) {
      var list = document.getElementById("cart_container_id");
      if (!list || !list.parentNode) return $();
      el = document.createElement("div");
      el.id = "mds-pending-slots";
      list.parentNode.insertBefore(el, list.nextSibling);
    }
    return $(el);
  }

  // Coalesce cart refreshes during a burst: each landed write still requests one, but at most
  // ~3 repaints per second actually run — a rebuild fires one product fetch PER ITEM, so an
  // uncapped 13-tap burst would mean 13 × 13 nested requests tearing at the list. The trailing
  // call always runs last, so the final paint is always the true cart.
  var mdsRefreshTimer = null;
  var mdsLastRefreshAt = 0;
  function mdsRequestCartRefresh() {
    var now = Date.now();
    if (now - mdsLastRefreshAt > 350) {
      mdsLastRefreshAt = now;
      if (window.updateCart) updateCart();
    } else if (!mdsRefreshTimer) {
      mdsRefreshTimer = setTimeout(function () {
        mdsRefreshTimer = null;
        mdsLastRefreshAt = Date.now();
        if (window.updateCart) updateCart();
      }, 380);
    }
  }

  // Click a charm tile (anywhere) to add it; click again to remove it (multi-select). Everything
  // is AJAX (no page reload). A skeleton row (the cart's own design) fills the item slot while the
  // request is in flight — a NEW slot on add, and the removed item's own slot on remove — then
  // updateCart() reconciles the list.
  $(document).on(
    "click",
    "[data-upsell] .cart-charm[data-variant-id]",
    function (e) {
      e.preventDefault();
      var $t = $(this);
      if ($t.hasClass("is-busy")) return;
      var vid = $t.attr("data-variant-id");
      var pressed = $t.attr("aria-pressed") === "true";
      // Optimistic: reflect the toggle immediately (updateCart re-confirms it after).
      $t.addClass("is-busy").attr("aria-pressed", pressed ? "false" : "true");
      $t.find(".cart-charm__add").text(pressed ? "+ ADD" : "ADDED");
      if (pressed) {
        // Remove — turn the removed item's own row into a skeleton while it's taken out.
        var $row = $("#cart_container_id [data-id='" + vid + "']").first();
        if ($row.length) $row.replaceWith(mdsCartSkeletonRow());
        else $("#cart_container_id").append(mdsCartSkeletonRow());
      } else {
        // Add — drop a placeholder into the rebuild-proof pending strip under the list, and
        // remember this variant came in VIA THE UPSELL so its tile stays visible as ADDED.
        var mdsAddedSet = mdsUpsellAddedIds();
        mdsAddedSet.add(String(vid));
        mdsUpsellSaveAddedIds(mdsAddedSet);
        mdsPendingSlots().append(mdsCartSkeletonRow());
      }
      // The WRITE is queued: Shopify applies concurrent cart writes in arbitrary order and
      // rate-limits bursts, so rapid taps fired in parallel could drop/scramble items. The
      // placeholder + tile state above stay instant; only the network call is serialized, and
      // the list repaints as EACH write lands (progressive, not all-at-the-end).
      // NB: the "json" dataType is REQUIRED — without it jQuery guesses "script" for the .js
      // endpoint and globalEval()s the JSON response, which throws and routes to .fail().
      mdsUpsellInFlight.set(String(vid), pressed ? "remove" : "add");
      var fire = function () {
        return (
          pressed
            ? $.post("/cart/change.js", { id: vid, quantity: 0 }, null, "json")
            : $.post("/cart/add.js", { quantity: 1, id: vid }, null, "json")
        )
          .fail(function (xhr) {
            // Roll back this tile's optimistic state; the reconcile below fixes the list.
            $t.removeClass("is-busy").attr("aria-pressed", pressed ? "true" : "false");
            $t.find(".cart-charm__add").text(pressed ? "ADDED" : "+ ADD");
            if (!pressed) {
              var undoSet = mdsUpsellAddedIds();
              undoSet.delete(String(vid));
              mdsUpsellSaveAddedIds(undoSet);
            }
          })
          .always(function () {
            mdsUpsellInFlight.delete(String(vid));
            if (!pressed) mdsPendingSlots().children().first().remove();
            // Progressive reconcile: each landed write requests a repaint (coalesced to ~3/s;
            // the trailing one always runs) — the first charm shows as a real row while later
            // ones still sit as placeholders. mdsCartSeq guards out-of-order responses.
            mdsRequestCartRefresh();
          });
      };
      // fire runs as BOTH fulfil and reject handler so one failed write never stalls the queue.
      mdsUpsellChain = mdsUpsellChain.then(fire, fire);
    }
  );

  // Category filter — the select dropdown shows only tiles whose product Type (data-category)
  // matches the chosen option ("all" shows everything). Client-side show/hide over the grid.
  $(document).on("change", "[data-upsell] .cart-upsell__filter-select", function () {
    var cat = this.value;
    var $wrap = $(this).closest(".cart-upsell");
    // .is-filtered kills the per-tile entry stagger so matched tiles appear INSTANTLY (no cascade
    // delay). Cleared on the next cart open so the entry animation still plays fresh.
    $wrap.find(".cart-upsell__grid").addClass("is-filtered");
    $wrap.find(".cart-charm").each(function () {
      this.style.display =
        cat === "all" || this.getAttribute("data-category") === cat ? "" : "none";
    });
    mdsUpsellFade(); // grid height changed → recompute the bottom fade
  });

  var mdsUpsellResizeT = null;
  window.addEventListener("resize", function () {
    clearTimeout(mdsUpsellResizeT);
    mdsUpsellResizeT = setTimeout(mdsUpsellSync, 150);
  });
  // Update the bottom fade as the charm grid is scrolled. Bound directly (scroll doesn't bubble, so
  // jQuery delegation won't fire); the listener survives the portal move between flyout/inline.
  var mdsGridEl = document.querySelector("[data-upsell] .cart-upsell__grid");
  if (mdsGridEl) mdsGridEl.addEventListener("scroll", mdsUpsellFade, { passive: true });
  mdsUpsellSync();
$(document).on("change", ".dropdown-btn", function (e) {
    var variantid = $("option:selected", this).attr("variantid");
    $.post(
      "/cart/add.js",
      {
        quantity: 1,
        id: variantid,
      },
      function (item) {
        updateCart();
      },
      "json"
    );
  });

  // new gift js
  $(".listvar-id a").click(function () {
    var newvar_id = $(this).attr("data-varoption");
    $(".product-form__cart-submit").attr("data-id", newvar_id);
  });

  $(document).on("click", ".digitalgift-btn", function (event) {
  event.preventDefault();
  event.stopImmediatePropagation(); // 🔥 MOST IMPORTANT

  const $btn = $(this);
  const $spinner = $btn.find(".loading-overlay__spinner");
  const $text = $btn.find(".custom-atc");

  $spinner.removeClass("hidden");
  $text.addClass("hidden");

  $("html").addClass("cart-open");

  $.post(
    "/cart/add.js",
    {
      quantity: 1,
      id: $btn.data("id"),
    },
    function () {
      updateCart();
      $(".cart_popup_wrap").addClass("activenav");
      $(".full_cart_loader").addClass("active");
    },
    "json"
  ).always(function () {
    $spinner.addClass("hidden");
    $text.removeClass("hidden");
  });
});


  // ends
  var shop_url = window.origin;
  /* === END MERGED-FROM-JOSH charm-grid engine === */

  function addToCart(variant_id, qty, props = null, ButtonName) {
    $(".product-form__error-message").text("");
      const items = [];

      // Check if bundle product exist
      if (window.bundleProducts && window.bundleProducts.length) {
        // Add all bundle products
        window.bundleProducts.forEach(function(product) {
          items.push({
            id: Number(product.variantId),
            quantity: Number(qty) * Number(product.quantity || 1)
          });
        });
        

      } else {
        // this is fo onlyy default products
        items.push({
          id: Number(variant_id),
          quantity: Number(qty),
          properties: props
        });
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: items
        })
      })
      .then(async response => {
        const data = await response.json();

        if (!response.ok) {
          throw data;
        }
        mdsMarkCartAddPending();
        $("#cartpopupboxnav").addClass("activenav loader_active");
        $("html").addClass("cart-open");
        updateCart();
        $(".loading-overlay__spinner").addClass("hidden");
        $(".custom-atc").removeClass("hidden");
        $(".gift-spin").addClass("hide");
      })
      .catch(function(error){

        $(".loading-overlay__spinner").addClass("hidden");
        $(".custom-atc").removeClass('hidden');

      });

      }

  $(document).on("click", ".cart_add_btn:not(.digitalgift-btn)", function (e) {
    e.preventDefault();
    var Ptext = $("input[name='properties[Text]']").val();
    var Pcolor = $("input[name='properties[Foil Colour]").val();
    var redcta = $("input[name='properties[Pre-Order]']").val();
    var ctaMessage = $("#prodefaultctamessage").data("prodefaultctamessage") || "";
    if ($("#input_curate_text").val() !== "") {
      var curatedtext = $("#input_curate_text").val();
    } else {
      var curatedtext = localStorage.getItem("mdsengraving2");
    }
    var variant_id = $(this).attr("data-id");
    var prohandle = $(this).attr("data-prodhandle");
    var redcta = $("input[name='properties[Pre-Order]']").val();
    var ButtonName = "main-atc";
    $(".loading-overlay__spinner").removeClass("hidden");
      $(".custom-atc").addClass('hidden');
    $(this).children(".gift-spin").removeClass("hide");
    if (
      variant_id == 40353994113105 ||
      variant_id == 42475620860086 ||
      variant_id == 40266306224209 ||
      Ptext == "" ||
      Pcolor == "" ||
      variant_id == 40329240936529
    ) {
      var props = {
        Text: "",
        "Foil Colour": "",
        Preorder: redcta,
        Phrase: "",
        "CTA Message": ctaMessage
      };
    } else {
      var props = {
        Text: Ptext,
        "Foil Colour": Pcolor,
        Preorder: redcta,
        Phrase: "",
        "CTA Message": ctaMessage
      };
    }
    if (curatedtext !== "") {
      var props = {
        Text: "",
        "Foil Colour": Pcolor,
        Preorder: redcta,
        Phrase: curatedtext,
        "CTA Message": ctaMessage
      };
    }
    let properties = props;
    var qty = 1;
    $(".full_cart_loader").addClass("active");
    if (
      props.Text != "" &&
      props.Text != null &&
      $(this).parent().find(".cart__props").hasClass("hide") == false
    ) {
      addToCart(variant_id, qty, properties, ButtonName);
    } else {
      addToCart(variant_id, qty, properties, ButtonName);
    }
  });
  $(document).on("click", ".floating_atc_button", function (e) {
    e.preventDefault();
    var Ptext = $("input[name='properties[Text]']").val();
    var Pcolor = $("input[name='properties[Foil Colour]").val();
    if ($("#input_curate_text").val() !== "") {
      var curatedtext = $("#input_curate_text").val();
    } else {
      var curatedtext = localStorage.getItem("mdsengraving2");
    }

    var variant_id = $(this).attr("data-id");
    var ButtonName = "sticky-atc";
    var redcta = $("input[name='properties[Pre-Order]']").val();
    var ctaMessage = $("#prodefaultctamessage").data("prodefaultctamessage") || "";
    if ($(this).attr("id") == "BIS_trigger") {
    } else {
      $(".loading-overlay__spinner").removeClass("hidden");
      $(".custom-atc").addClass('hidden');

      if (
        variant_id == 42475620860086 ||
        variant_id == 40266306224209 ||
        Ptext == "" ||
        Pcolor == "" ||
        curatedtext == ""
      ) {
        var props = {
          Text: "",
          "Foil Colour": "",
          Preorder: redcta,
          Phrase: "",
          "CTA Message": ctaMessage
        };
      } else {
        var props = {
          Text: "",
          "Foil Colour": "",
          Preorder: redcta,
          Phrase: "",
          "CTA Message": ctaMessage
        };
      }
      if (curatedtext !== "") {
        var props = {
          Text: "",
          "Foil Colour": Pcolor,
          Preorder: redcta,
          Phrase: curatedtext,
          "CTA Message": ctaMessage
        };
      }
      let properties = props;
      var qty = 1;
      $(".full_cart_loader").addClass("active");
      if (
        props.Text != "" &&
        props.Text != null &&
        $(this).parent().find(".cart__props").hasClass("hide") == false
      ) {
        addToCart(variant_id, qty, properties, ButtonName);
      } else {
        addToCart(variant_id, qty, properties, ButtonName);
      }
    }
  });

  $(document).on("click", ".free_gift_product_aus", function (e) {
    e.preventDefault();
    var variant_id = $(this).attr("data-id");
    $(".loading-overlay__spinner").removeClass("hidden");
    $(".custom-atc").addClass('hidden');
    $(this).children(".gift-spin").removeClass("hide");
    var ButtonName = "";
    if (variant_id == 42475620860086 || variant_id == 42123517460662 || variant_id == 43947817238710 || variant_id == 44131436921014 ) {
      var props = {
        Text: "",
        "Foil Colour": "",
        curated: "",
      };
    } else {
      var props = {
        Text:
          localStorage.getItem("mdsEngraving") != null
            ? localStorage.getItem("mdsEngraving")
            : "",
        "Foil Colour":
          localStorage.getItem("mdsEngraving") != null
            ? localStorage.getItem("mdsFoil")
            : "",
        curated:
          localStorage.getItem("mdsengraving2") != null
            ? localStorage.getItem("mdsengraving2")
            : "",
      };
    }
    let properties = props;
    var qty = 1;
    if (
      props.Text != "" &&
      props.Text != null &&
      $(this).parent().find(".cart__props").hasClass("hide") == false
    ) {
      addToCart(variant_id, qty, properties, ButtonName);
    } else {
      addToCart(variant_id, qty, properties, ButtonName);
    }
  });
  $(document).on("click", ".cart_add_btn_gift_cart", function (e) {
    e.preventDefault();
    $(".loading-overlay__spinner").removeClass("hidden");
    $(".custom-atc").addClass('hidden');
    $(this).children(".gift-spin").removeClass("hide");
    var variant_id = $(this).attr("data-id");
    var ButtonName = "";
    if (variant_id == 42475620860086 || variant_id == 40255413420113) {
      var props = {
        Text: "",
        "Foil Colour": "",
        curated: "",
      };
    } else {
      var props = {
        Text:
          localStorage.getItem("mdsEngraving") != null
            ? localStorage.getItem("mdsEngraving")
            : "",
        "Foil Colour":
          localStorage.getItem("mdsEngraving") != null
            ? localStorage.getItem("mdsFoil")
            : "",
        Phrase:
          localStorage.getItem("mdsengraving2") != null
            ? localStorage.getItem("mdsengraving2")
            : "",
      };
    }

    let properties = props;
    var qty = 1;
    if (
      props.Text != "" &&
      props.Text != null &&
      $(this).parent().find(".cart__props").hasClass("hide") == false
    ) {
      addToCart(variant_id, qty, properties, ButtonName);
    } else {
      addToCart(variant_id, qty, properties, ButtonName);
    }
  });

  function makeitmatchpdp(color) {
    var x = 0;
    $(
      ".grid__item .card-wrapper .container_product-colors .list_product-colors .swiper-wrapper .swiper-slide .color-option span"
    ).each(function () {
      var input_color_value = $(this).attr("data-color");
      if (input_color_value == color) {
        var split_data = $(this)
          .parents()
          .parents(".swiper-slide")
          .attr("aria-label")
          .split("/");
        if (typeof split_data != "undefined") {
          var index = $(this)
            .parents()
            .parents()
            .parents()
            .parents()
            .parents()
            .parents(".grid__item")
            .attr("data-index");
          $(this).trigger("mouseenter");
          x++;
          swiper[index].slideTo(split_data[0]);
        }
      }
    });
  }
  function generateMatchingItems(items, parent_class, item_class, colour) {
    let output = document.createElement("div");
    output.setAttribute("class", parent_class);
    if (items.length == 1) {
      output.classList.add("lefty");
    }
    const limit = 4;
    let toShow = items.length < limit ? items.length : limit;
    for (let i = 0; i < toShow; i++) {
      let product = items[i];
      let variant = "";
      if (product.product_type.includes("Watch")) {
        variant = product.variants.filter(function (variant) {
          return variant.option2 == colour;
        })[0];
      } else {
        variant = product.variants.filter(function (variant) {
          return variant.option1 == colour;
        })[0];
      }
      let varURL = "/products/" + product.handle + "?variant=" + variant.id;
      var preorder_matching = document.querySelector("#preorder" + product.id);
      let is_preorder_matching = false;
      var preorder_text = null;
      if (preorder_matching != null) {
        let variants_matching = preorder_matching.value.split(",");
        for (var j = 0; j < variants_matching.length; j++) {
          let values = variants_matching[j].split(":");
          if (values[0] == variant.id) {
            preorder_matching = values[1] == "true";
          }
        }
      }
      if (preorder_matching) {
        for (var x = 0; x < product.tags.length; x++) {
          if (product.tags[x].includes("eta:")) {
            preorder_text = product.tags[x].split(":")[1];
          }
        }
      }

      let product_wrapper = document.createElement("div");
      product_wrapper.setAttribute("class", item_class);
      output.appendChild(product_wrapper);

      let featured_item = document.createElement("div");
      featured_item.classList.add("featured-item");
      product_wrapper.appendChild(featured_item);

      let featured_product_image = document.createElement("div");
      featured_product_image.classList.add("feautred-product-image");
      featured_item.appendChild(featured_product_image);

      let image_link = document.createElement("a");
      image_link.classList.add("image-link");
      image_link.setAttribute("href", varURL);
      featured_product_image.appendChild(image_link);

      let image_wrapper = document.createElement("div");
      image_wrapper.setAttribute(
        "class",
        "grid-view-item__image-wrapper product-card__image-wrapper js product-image-fix"
      );
      image_wrapper.classList.add(
        variant.option1.replace(/ /g, "-").toLowerCase()
      );
      image_link.appendChild(image_wrapper);

      let rel = document.createElement("div");
      rel.classList.add("relative");
      image_wrapper.appendChild(rel);

      let image = document.createElement("img");
      image.setAttribute("class", "grid-view-item__image active");
      image.setAttribute("src", variant.featured_image.src);
      rel.appendChild(image);

      let is_art_series = product.tags.indexOf("customize_artwork") != -1;
      // zodiac
      let is_zodiac_series = product.tags.indexOf("customize_zodiac") != -1;

      let is_airpods_pro = product.tags.indexOf("airpods_pro") != -1;
      let mini_clutch = product.tags.indexOf("mini_clutch") != -1;

      let eng = is_zodiac_series
        ? "engrave icon-chess-piece"
        : is_art_series
        ? "artwork-engrave"
        : is_airpods_pro
        ? "engrave icon-chess-piece airpods-pro"
        : mini_clutch
        ? "engrave icon-chess-piece mini-clutch"
        : "engrave icon-chess-piece";

      let text_class =
        eng +
        " " +
        product.product_type.replace(/ /g, "-").toLowerCase() +
        " " +
        foil.get();
      let text = document.createElement("div");

      if (is_zodiac_series) {
        text.classList.add(zodiac.get().replace(/ /g, "-").toLowerCase());
      }
      if (is_art_series) {
        text.classList.add(artwork.get().replace(/ /g, "-").toLowerCase());
      } else {
        text.innerText = initials.get(product.product_type);
      }
      text.setAttribute("class", text_class);
      rel.appendChild(text);

      let featured_details = document.createElement("div");
      featured_details.classList.add("featured-details");
      featured_details.classList.add("rte");
      featured_item.appendChild(featured_details);

      let p_link = document.createElement("a");
      p_link.setAttribute("href", varURL);
      featured_details.appendChild(p_link);

      let p_title = document.createElement("h4");
      p_title.innerHTML = variant.option1 + "<br>" + product.title;
      p_link.appendChild(p_title);

      let p_price_wrap = document.createElement("div");
      p_price_wrap.classList.add("price");
      featured_details.appendChild(p_price_wrap);

      if (
        variant.compare_at_price != null &&
        product.product_type != "Gift Boxes & Tins"
      ) {
        let variant_compare_price = document.createElement("span");
        variant_compare_price.classList.add("price");
        variant_compare_price.classList.add("compare_price_matching");
        variant_compare_price.classList.add("cart_text");
        var currencySymbol = window.mdsCurrency?.symbol || window.sgcr_localization?.country?.currency?.symbol || "$";
        variant_compare_price.innerHTML = currencySymbol + (Number(variant.compare_at_price) / 100);
        p_price_wrap.appendChild(variant_compare_price);
      }

      let p_price = document.createElement("span");
      p_price.setAttribute("class", "price-item price-item--regular");
      if (variant.compare_at_price != null) {
        p_price.setAttribute("class", "compare_price_color");
      }
      p_price.innerText = currencySymbol + (Number(variant.price) / 100);
      p_price_wrap.appendChild(p_price);

      let p_info = document.createElement("p");
      p_info.innerHTML = product.body_html;

      p_info.innerHTML = mdsProductDes(product.product_type, mini_clutch);
      featured_details.appendChild(p_info);
      p_info.outerHTML += "<br>";

      let p_add = document.createElement("a");
      p_add.setAttribute(
        "class",
        "btn btn--pill text-upper add-to-bag ajax-atc"
      );
      p_add.setAttribute("href", varURL);
      p_add.setAttribute("data-variant", variant.id);
      p_add.setAttribute("data-art", is_art_series);
      p_add.setAttribute("data-zodiac", is_zodiac_series);
      p_add.setAttribute("p-type", product.product_type);
      p_add.setAttribute("preorder-text", preorder_text);
      p_add.innerText = preorder_matching ? "Pre-Order" : cart_add;
      featured_details.appendChild(p_add);
    }

    return output;
  }
  function updateMatchingItems(type, colour) {
    const forNotMatchTag = "notmatch2"; //for airpods
    $.getJSON(
      "/collections/matching-slider/products.json",
      function (recommendations) {
        var items = [];
        var recommendedProducts = recommendations.products.filter(function (
          product
        ) {
          return product.product_type != type;
        });
        if (recommendedProducts.length > 0) {
          recommendedProducts.map(function (product) {
            if (!(product.tags.indexOf(forNotMatchTag) != -1)) {
              //for airpods
              let sameColour =
                product.options[product.options.length - 1].values.indexOf(
                  colour
                ) != -1;
              if (sameColour) {
                items.push(product);
              }
            }
          });
          if (items.length > 0) {
            let matching_items_desktop = generateMatchingItems(
              items,
              "grid grid--uniform",
              "grid__item medium-up--one-half",
              colour
            );
            let matching_items_mobile = generateMatchingItems(
              items,
              "css-slider",
              "css-slider_slide",
              colour
            );

            document.querySelector("#product-matching-desktop").innerHTML =
              matching_items_desktop.outerHTML;
            document.querySelector("#product-matching-mobile").innerHTML =
              matching_items_mobile.outerHTML;

            $(".ajax-atc").click(function (e) {
              e.preventDefault();

              let props = {
                Text: initials.get($(this).attr("p-type")),
                "Foil Color": foil.get(),
                "Pre-order":
                  $(this).attr("preorder-text") != "null"
                    ? $(this).attr("preorder-text")
                    : "",
              };
              if (this.dataset.art == "true") {
                props = {
                  Artwork: artwork.get(),
                  "Foil Color": "Gold",
                };
              }
              if (this.dataset.zodiac == "true") {
                props = {
                  Zodiac: zodiac.get(),
                  "Foil Color": foil.get(),
                };
              }

              let form_data = {
                quantity: 1,
                id: this.dataset.variant,
                properties: props,
              };

              $.post(
                "/cart/add.js",
                form_data,
                function (item) {
                  mdsMarkCartAddPending();

                  updateCart();

                  $("#cartMenu").addClass("open");
                  $("html").addClass("no-scroll");
                },
                "json"
              );
            });
          } else {
            updateMatchingItems(type, "Black Caviar");
          }
        }
      }
    );
  }
  function updateCartItem(line, qty) {
    $.post(
      shop_url + "/cart/change.js",
      {
        line: line,
        quantity: qty,
      },
      function (result) {
        updateCart();
      },
      "json"
    );
  }

  // Free-gift threshold ($200) check. Defined once, at top level, instead of
  // being redefined + re-bound inside updateCart()'s per-item render loop
  // (that old version created a new document click-listener for every single
  // line item on every cart refresh, which piled up duplicate listeners for
  // the life of the page).
  var giftVariantId = 44131436921014;
  function checkAndRemoveGift() {
    fetch("/cart.js")
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var cartTotal = cart.total_price / 100; // Convert from cents to dollars
        var threshold = 200;
        var giftItem = cart.items.find(function (item) {
          return item.variant_id === giftVariantId;
        });

        if (cartTotal < threshold && giftItem) {
          // Remove the gift item if cart value is below $200
          fetch("/cart/change.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              id: giftItem.key,
              quantity: 0,
            }),
          })
            .then(function (res) {
              return res.json();
            })
            .then(function (updatedCart) {
              // Optionally update cart UI or reload cart drawer
              updateCart();
            });
        }
      });
  }

  // Bound once (outside updateCart) instead of once per cart line item.
  $(document).on(
    "click",
    ".cart_add_btn, .cart_remove_item, .qty-adjust-button",
    function () {
      setTimeout(checkAndRemoveGift, 100);
    }
  );

  // matching items on change
  $(".color-swatch").click(function () {
    var personalizationtext = $(this).attr("data-personalize");
    if (personalizationtext == true || personalizationtext == "true") {
      var Ptext = $("input[name='properties[Text]']").val("");
      var Pcolor = $("input[name='properties[Foil Colour]").val("");
    }
    var type = $(this).attr("data-pdtype");
    var colour = $(this).attr("data-color");
    var clrswatchid = $(this).attr("data-clrid");
    var checkavailabilitynew = $(this).attr("data-available");
    $("body").find(".customcartbtn").attr("data-id", clrswatchid);
    $("body").find(".floating_atc_button").attr("data-id", clrswatchid);
    if (checkavailabilitynew == "false" || checkavailabilitynew == false) {
      setTimeout(function () {
        $("body").find(".floating_atc_button").attr("id", "BIS_trigger");
        $("body")
          .find(".floating_atc_button .custom_atc_text_name")
          .text("Join the Waitlist");
      }, 500);
    } else {
      setTimeout(function () {
        $("body")
          .find(".floating_atc_button .custom_atc_text_name")
          .text("Add To Bag");
        $("body").find(".floating_atc_button").attr("id", "");
        $("body").find(".customcartbtn").attr("id", "");
      }, 500);
    }
    makeitmatchpdp(colour);
  });

  // Parses a "line:qty,line:qty" data-lines attribute (written by updateCart's
  // merge logic) into [{line, qty}, ...]. Returns [] if the attribute is
  // missing/empty, so callers can fall back to the plain single data-line
  // behaviour.
  function parseMergedCartLines(linesAttr) {
    if (!linesAttr) return [];
    return linesAttr
      .split(",")
      .filter(function (pair) {
        return pair.indexOf(":") !== -1;
      })
      .map(function (pair) {
        var parts = pair.split(":");
        return { line: parseInt(parts[0], 10), qty: parseInt(parts[1], 10) };
      });
  }

  // Zeroes out every underlying Shopify cart line in a merged group, highest
  // line number first. (Removing a line shifts every *later* line down by
  // one, so we must go highest-to-lowest to keep the remaining line numbers
  // valid between requests.)
  function removeMergedCartLines(mergedLines) {
    var sorted = mergedLines.slice().sort(function (a, b) {
      return b.line - a.line;
    });
    function removeNext(index) {
      if (index >= sorted.length) {
        updateCart();
        return;
      }
      $.post(
        shop_url + "/cart/change.js",
        { line: sorted[index].line, quantity: 0 },
        function () {
          removeNext(index + 1);
        },
        "json"
      );
    }
    removeNext(0);
  }

  // Remove Item from Cart
  $(document).on("click", ".remove_cart_item", function () {
    $(this).parent().parent().parent().parent().addClass("cart_loading");
    $(this)
      .parent()
      .parent()
      .parent()
      .parent()
      .find(".cart_popup_bg")
      .removeClass("hide");
    var mergedLines = parseMergedCartLines($(this).attr("data-lines"));
    if (mergedLines.length > 0) {
      removeMergedCartLines(mergedLines);
    } else {
      // Fallback: no merge data present, behave exactly as before.
      var line = $(this).attr("data-line");
      var qty = 0;
      updateCartItem(line, qty);
    }
  });

  $(".matching-heading").click(function (event, empty = null) {
    if (empty != null && empty == "open") {
      $(this).addClass("open");
    } else {
      $(this).toggleClass("open");
    }
    if ($(this).hasClass("open")) {
      $(".cart__matching").css("background", "#f4f4f4");
      $(".css-slider").slideDown(300, function () {});
    } else {
      $(".cart__matching").css("background", "#fff");
      $(".css-slider").slideUp(300, function () {});
    }
  });

  // Increment Item IN Cart
  $(document).on("click", ".cart_item_plus", function () {
    $(this)
      .parent()
      .parent()
      .parent()
      .parent()
      .parent()
      .parent()
      .addClass("cart_loading");
    $(this)
      .parent()
      .parent()
      .parent()
      .parent()
      .parent()
      .parent()
      .find(".cart_popup_bg")
      .removeClass("hide");
    var input_val = $(this)
      .closest(".QuantityBox")
      .find(".QuantityInput")
      .val();
    input_val = Number(input_val) + 1;
    $(this).closest(".QuantityBox").find(".QuantityInput").val(input_val);
    var variant_id = $(this).attr("variant_id");

    var mergedLines = parseMergedCartLines($(this).attr("data-lines"));
    if (mergedLines.length > 0) {
      // Bump the first underlying line in the group by 1. The merged total
      // shown in the drawer will pick up the +1 on the next updateCart().
      var firstLine = mergedLines[0];
      updateCartItem(firstLine.line, firstLine.qty + 1);
    } else {
      // Fallback: no merge data present, behave exactly as before.
      var qty = $(this).closest(".QuantityBox").find(".QuantityInput").val();
      var line = $(this).attr("data-line");
      updateCartItem(line, qty);
    }
  });

  // Decrement Item IN Cart
  $(document).on("click", ".cart_item_minus", function () {
    $(this)
      .parent()
      .parent()
      .parent()
      .parent()
      .parent()
      .parent()
      .addClass("cart_loading");
    $(this)
      .parent()
      .parent()
      .parent()
      .parent()
      .parent()
      .parent()
      .find(".cart_popup_bg")
      .removeClass("hide");
    var input_val = $(this)
      .closest(".QuantityBox")
      .find(".QuantityInput")
      .val();
    input_val = Number(input_val) - 1;
    $(this).closest(".QuantityBox").find(".QuantityInput").val(input_val);

    var mergedLines = parseMergedCartLines($(this).attr("data-lines"));
    if (mergedLines.length > 0) {
      // Decrement from the last underlying line that still has quantity left,
      // so the group naturally collapses down to fewer real lines over time.
      for (var mi = mergedLines.length - 1; mi >= 0; mi--) {
        if (mergedLines[mi].qty > 0) {
          updateCartItem(mergedLines[mi].line, mergedLines[mi].qty - 1);
          break;
        }
      }
    } else {
      // Fallback: no merge data present, behave exactly as before.
      var qty = $(this).closest(".QuantityBox").find(".QuantityInput").val();
      var line = $(this).attr("data-line");
      updateCartItem(line, qty);
    }
  });

  //updateCart();

  function addMatchingItem(
      btn,
      variant,
      is_art_series,
      is_zodiac_series,
      is_upsell,
      productType,
      preorder_text,
      Phrase
    ) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      $(".matching-heading").trigger("click");
      $(".matching__atc").addClass("hide");
      $(".adding_atc").removeClass("hide");
      $(".adding_atc").attr("disabled", true);
      let btn_text = $(this).find("[data-add-to-cart-text]")[0];
      let btn_loader = $(this).find("[data-loader]")[0];
      if (btn_text != null && btn_loader != null) {
        btn_text.classList.add("hide");
        btn_loader.classList.remove("hide");
      }

      let props = {};

      const personalizableProducts = [
        "Phone Case",
        "The Phone Case",
        "Card Phone Case",
        "Sling Phone Case",
        "AirPods",
        "Laptop Sleeve"
      ];

      const isPersonalizable = personalizableProducts.some(type =>
        productType.includes(type)
      );

      if (isPersonalizable) {
        props = {
          Text: initials.get(productType),
          "Foil Color": foil.get(),
          "Pre-order": preorder_text,
        };
      }

      if (
        $(btn).hasClass("upsell_item--add") ||
        $(".slider_matching--items").hasClass("screen-protector") ||
        $(".slider_matching--items").hasClass("leather-protectant") || 
        $(".slider_matching--items").hasClass("airtag-charm")
      ) {
        props = {
          Text: "",
          "Foil Color": "",
          Phrase: ""
        };
      }
      if (is_art_series) {
        props = {
          Artwork: artwork.get(),
          "Foil Color": "Gold",
        };
      }

      //Zodiac
      if (is_zodiac_series) {
        props = {
          Zodiac: zodiac.get(),
          "Foil Color": "Gold",
        };
      }

      $.post(
        "/cart/add.js",
        {
          quantity: 1,
          id: variant.id,
          properties: props,
        },
        function (item) {
          mdsMarkCartAddPending();

          updateCart();

          if (btn_text != null && btn_loader != null) {
            btn_text.classList.remove("hide");
            btn_loader.classList.add("hide");
          }
        },
        "json"
      );
    });
  }

  function checkDisneycolor(col) {
    if (
      col.includes("Pluto") ||
      col.includes("Donald") ||
      col.includes("Daisy") ||
      col.includes("Mickey") ||
      col.includes("Minnie") ||
      col.includes("Goofy") ||
      col.includes("Tempered")
    ) {
      return true;
    }
    return false;
  }

  function checkdisneycolour(col) {
    if (col.includes("Pluto")) {
      return "Emerald Green";
    }
    if (col.includes("Donald")) {
      return "Sky Blue";
    }
    if (col.includes("Daisy")) {
      return "Lavender Purple";
    }
    if (col.includes("Mickey")) {
      return "Pomegranate Red";
    }
    if (col.includes("Minnie")) {
      return "Pink Lily";
    }
    if (col.includes("Goofy")) {
      return "Manhattan Orange";
    }
    return col;
  }

  function checkForMatch(cart, product, itemToMatch) {
    let notInCart =
      cart.items.filter(function (line_item) {
        return line_item.product_id == product.id;
      }).length <= 0;
    let differentType = product.product_type != itemToMatch.product_type;
    let typeNotInCart =
      cart.items.filter(function (line_item) {
        return line_item.product_type == product.product_type;
      }).length <= 0;
    if (product.product_type == "Screen Protector") {
      typeNotInCart = true;
      differentType = true;
    }

    return notInCart && differentType && typeNotInCart;
  }

  function getMatchingItems(container = "", cart) {
    if (!container) return;
    var cartVarSet = new Set();
    if (cart && cart.items) {
      cart.items.forEach(function (it) {
        cartVarSet.add(String(it.id));
        if (it.variant_id != null) cartVarSet.add(String(it.variant_id));
      });
    }
    var upsellAdded = mdsUpsellAddedIds();
    var pruned = false;
    container.querySelectorAll(".cart-charm[data-variant-id]").forEach(function (t) {
      var vid = String(t.getAttribute("data-variant-id"));
      // Write still queued → this snapshot predates it; keep the tile's optimistic state
      // (its own write's refresh will confirm it).
      if (mdsUpsellInFlight.has(vid)) return;
      var inCart = cartVarSet.has(vid);
      t.classList.remove("is-busy");
      t.setAttribute("aria-pressed", inCart ? "true" : "false");
      // In the cart but NOT via the upsell (PDP, customizer, ...) → exclude the tile from the
      // grid. Added from the upsell → stays visible as ADDED for feedback. Once the item leaves
      // the cart, forget the upsell flag so a later external add excludes it again.
      t.classList.toggle("is-incart-external", inCart && !upsellAdded.has(vid));
      if (!inCart && upsellAdded.has(vid)) {
        upsellAdded.delete(vid);
        pruned = true;
      }
      var add = t.querySelector(".cart-charm__add");
      if (add) add.textContent = inCart ? "ADDED" : "+ ADD";
    });
    if (pruned) mdsUpsellSaveAddedIds(upsellAdded);
    mdsUpsellSync();
  }

function updateCart() {
  let valGiftCounter = new Array(1);
  valGiftCounter.fill(0);
  let valInCart = false;
  let valInCart2 = false;
  let valInCart3 = false;
  let alreadyIncart = false;
  let addFreeItem = false;
  let valId = "41108196393142";
  let valId3 = "41108196425910";
  let valId2 = "3955601139320ddd6";
  let card_id = "";
  let valQty = 0;
  let val2Qty = 0;
  let val3Qty = 0;
  let emerald = 0;
  let gift_outer = null;
  var gift_counter = 0;
  let gift_line_item = new Array(15);
  let counter = 0;
  let card_qty = 0;
  let phone_cases_qty = 0;
  let protector_is = 0;
  let card_qty_id = 0;
  let pro_var_id = "";
  let phone_case = false;
  let sticker_qty = 0;
  var cartItems = [];
  var cartAppendata = "";
  var shop_currency = $("#shop_currency_val").text();
  var shop_currency_sym = shop_currency.split(".")[0];
  $("#upsell-cart-items-add").empty();
  const matchingItems = document.querySelector(".cart-matching-slider");
  const ap_Price = document.querySelector(".cart-ap-price");

  // ---- FIX: force a fresh request instead of a browser-cached response ----
  jQuery.getJSON({
    url: window.origin + "/cart.js",
    cache: false,
  }).done(async function (cart) {
    let items_custome = cart.items;
    var total_cart_length = cart.item_count;
    var upsellProductCount = cart.items.length;
    mdsUpsellCurrentProductCount = upsellProductCount; // Little Luxuries uses number of cart products/lines,
    $("html").toggleClass("cart-has-items", total_cart_length > 0); // Little Luxuries CSS reveal gate

    // ------------------------------------------------------------
    // Little Luxuries initial cart state
    // ------------------------------------------------------------
    if (!mdsUpsellInitialStateApplied) {
      mdsUpsellInitialStateApplied = true;

      if (
        upsellProductCount > 1 &&
        window.matchMedia("(max-width: 991px)").matches
      ) {
        if (window.mdsUpsellAutoCollapse) {
          window.mdsUpsellAutoCollapse();
        }
      }
    }

    // ------------------------------------------------------------
    // Little Luxuries cart-state handling
    // ------------------------------------------------------------
    var previousUpsellCartCount = mdsUpsellLastCartItemCount;

    var upsellWentFromMultipleToOne =
      previousUpsellCartCount !== null &&
      previousUpsellCartCount > 1 &&
      upsellProductCount === 1;

    var upsellWentToEmpty = upsellProductCount === 0;

    if (upsellWentFromMultipleToOne) {
      mdsUpsellUserCollapsed = false;

      var upsellFilter = document.querySelector(
        "[data-upsell] .cart-upsell__filter-select"
      );

      if (upsellFilter) {
        upsellFilter.value = "all";
        $(upsellFilter).trigger("change");
      }
    }

    if (upsellWentToEmpty) {
      mdsUpsellUserCollapsed = false;
    }

    mdsUpsellLastCartItemCount = upsellProductCount;

    $("#cart-title span").text(cart.item_count);
    $("#cartopennavmov span.btn-cart-trigger__count").text(cart.item_count);
    if (cart.item_count > 0) {
      $("#cartopennav span.btn-cart-trigger__count").text(cart.item_count);
    }
    var subtotalCart = Number(cart.total_price) / 100;
    var subtotal = subtotalCart.toFixed(2);
    var splittotal = subtotal.split(".");

    // Current Shopify Markets currency
    var currencySymbol = window.mdsCurrency?.symbol || window.sgcr_localization?.country?.currency?.symbol || "$";
    if (splittotal[1] == "00") {
      var nodecimaltotal = currencySymbol + Math.trunc(subtotal);
    } else {
      var nodecimaltotal = currencySymbol + subtotal;
    }

  $(".cart_final_subtotal_price").text(nodecimaltotal);
    if (subtotalCart != null) {
      ap_Price.innerHTML = Math.round(cart.total_price / 400);
    }

    if (total_cart_length == 0) {
      $(".btn-cart-trigger__count").addClass("hide");
      $(".header-cart__progg").show();
      $(".emptycart__contents").show();
      $(".content-cart-nav").show();
      $("#cart_container_id").empty();
      $(".cart-footer-nav").hide();
      $(".gift_product").hide();
      $(".upsellempy").hide();
      $(".cart_gift_box").addClass("hide");
      $(".content-cart-nav .not-empty-cart").hide();
      $(".cart__matching").hide();
      $(".full_cart_loader").removeClass("active");
      return; // nothing else to do for an empty cart
    }

    $(".btn-cart-trigger__count").removeClass("hide");
    $("#cartpopupboxnav").removeClass("loader_active");
    var is_mini_tote_free_gift = false;
    var is_mini_tote_free_gift_comp = false;
    if (total_cart_length == 1) {
      if (cart.items[0].id == "44131436921014") {
        $.post(
          "/cart/clear.js",
          function (cart) {
            updateCart();
          },
          "json"
        );
      }
    }
    $(".cart__matching").show();
    getMatchingItems(matchingItems, cart);

    // ------------------------------------------------------------
    // Little Luxuries state after cart refresh
    // ------------------------------------------------------------
    if (window.mdsUpsellSync) {
      window.mdsUpsellSync();
    }

    // ------------------------------------------------------------
    // Little Luxuries auto-open / auto-collapse
    // ------------------------------------------------------------
    if (mdsUpsellAutoActionTimer) {
      clearTimeout(mdsUpsellAutoActionTimer);
      mdsUpsellAutoActionTimer = null;
    }

    var shouldAutoOpenUpsell = mdsUpsellAutoOpenPending;
    mdsUpsellAutoOpenPending = false;

    if (window.matchMedia("(max-width: 991px)").matches) {
      /*
       * MOBILE:
       * 0 products -> closed
       * 1 product  -> open/peek after an add
       * 2+ products -> ALWAYS collapsed
       */
        if (upsellProductCount > 1) {
          if (window.mdsUpsellAutoCollapse) {
            window.mdsUpsellAutoCollapse();
          }
        } else if (upsellProductCount === 1 && shouldAutoOpenUpsell) {
          mdsUpsellAutoActionTimer = setTimeout(function () {
            mdsUpsellAutoActionTimer = null;
            var latestUpsellProductCount = mdsUpsellCurrentProductCount;
            if (latestUpsellProductCount > 1) {
              if (window.mdsUpsellAutoCollapse) {
                window.mdsUpsellAutoCollapse();
              }
              return;
            }
            if (latestUpsellProductCount === 1) {
              if (window.mdsUpsellAutoOpen) {
                window.mdsUpsellAutoOpen();
              }
            }
          }, 100);
        }
    } else {
      // Desktop keeps the existing behaviour.
      if (shouldAutoOpenUpsell && window.mdsUpsellAutoOpen) {
        window.mdsUpsellAutoOpen();
      }
    }

    if (upsellWentFromMultipleToOne) {
      mdsUpsellUserCollapsed = false;

      requestAnimationFrame(function () {
        if (window.mdsUpsellSync) {
          window.mdsUpsellSync();
        }

        requestAnimationFrame(function () {
          if (window.mdsUpsellMeasure) {
            window.mdsUpsellMeasure();
          }
        });
      });
    }

    $(".header-cart__progg").hide();
    $(".emptycart__contents").hide();
    $(".cart-footer-nav").show();
    $(".upsellempy").show();
    $(".cart_gift_box").removeClass("hide");
    $(".content-cart-nav .not-empty-cart").show();
    cartItems = cart.items;

    // ------------------------------------------------------------
    // Preload all product JSON in parallel.
    //
    // IMPORTANT:
    // Do this BEFORE rendering the cart rows so updateCart()
    // never waits for product 1, then product 2, then product 3.
    // Cached products resolve immediately on later cart refreshes.
    // ------------------------------------------------------------
    var productJsonMap = {};

    var uniqueProductUrls = Array.from(
      new Set(
        cartItems
          .map(function (item) {
            return item.url;
          })
          .filter(Boolean)
      )
    );

    await Promise.all(
      uniqueProductUrls.map(function (productUrl) {
        return mdsGetProductJson(productUrl)
          .then(function (data) {
            productJsonMap[productUrl] = data;
          })
          .catch(function (err) {
            console.warn(
              "[cart] product JSON lookup failed for " + productUrl,
              err
            );
            productJsonMap[productUrl] = null;
          });
      })
    );

    // ---- MERGE DUPLICATE LINE ITEMS FOR DISPLAY -------------------------
    function normalizeCartItemPropertiesKey(properties) {
      if (!properties) return "";

      var KEY_ALIASES = {
        "foil color": "foil colour",
        "pre-order": "preorder",
      };

      var normalized = {};
      var keys = Object.keys(properties);
      for (var k = 0; k < keys.length; k++) {
        var rawKey = keys[k];
        var val = properties[rawKey];
        if (val === null || typeof val === "undefined") continue;
        val = String(val).trim();
        if (val === "") continue;

        var lowerKey = rawKey.trim().toLowerCase();
        var canonicalKey = KEY_ALIASES[lowerKey] || lowerKey;
        normalized[canonicalKey] = val;
      }

      var sortedKeys = Object.keys(normalized).sort();
      var parts = [];
      for (var i = 0; i < sortedKeys.length; i++) {
        parts.push(sortedKeys[i] + "=" + normalized[sortedKeys[i]]);
      }
      return parts.join("|");
    }

    var variantLineGroups = {};
    for (var vgi = 0; vgi < cartItems.length; vgi++) {
      var vgLineNumber = vgi + 1; // Shopify's 1-based line index
      var vgKey =
        cartItems[vgi].variant_id +
        "::" +
        normalizeCartItemPropertiesKey(cartItems[vgi].properties);
      if (!variantLineGroups[vgKey]) {
        variantLineGroups[vgKey] = {
          firstIndex: vgi,
          totalQty: 0,
          lines: [],
        };
      }
      variantLineGroups[vgKey].totalQty += cartItems[vgi].quantity;
      variantLineGroups[vgKey].lines.push({
        line: vgLineNumber,
        qty: cartItems[vgi].quantity,
      });
    }
    // ---- END MERGE SETUP -------------------------------------------------

    let props = {
      Text:
        localStorage.getItem("mdsEngraving") != null
          ? localStorage.getItem("mdsEngraving")
          : "",
      "Foil Colour":
        localStorage.getItem("mdsEngraving") != null
          ? localStorage.getItem("mdsFoil")
          : "",
      Phrase:
        localStorage.getItem("mdsengraving2") != null
          ? localStorage.getItem("mdsengraving2")
          : "",
    };
    var prsnlize_clr = props["Foil Colour"];
    var p = 1;
    var $cartContainer = $("#cart_container_id");
    var sale_text = "";
    var hasNewFreeGift = false;
    var newCartHtml = "";

    for (var i = 0; i < cartItems.length; i++) {
      if (cartItems[i].product_type === "newfreegift") {
        hasNewFreeGift = true;
        break;
      }
    }
    if (hasNewFreeGift) {
      $(".free_gift_product_aus").addClass("cstdisabled");
      $(".cart_gift_box.c_free_gift_box").addClass("hide");
    } else {
      $(".free_gift_product_aus").removeClass("cstdisabled");
      $(".cart_gift_box.c_free_gift_box").removeClass("hide");
    }

    // ============================================================
    // FIX #1 (iOS shipping bar root cause):
    // .min_free_values / .min_free_valuesforfreegift may not exist
    // in the mobile cart drawer markup. Reading .attr("data-varlu")
    // from an empty jQuery selection returns `undefined`, and
    // `final_total < undefined` always evaluates to false. That
    // silently sends mobile into the wrong branch every time and
    // the bar looks "stuck" / never updates correctly.
    //
    // Fix: coerce to Number with a safe fallback, and warn loudly
    // in the console so this is easy to spot in Safari's remote
    // inspector if the markup really is missing on mobile.
    // ============================================================
    var shippingTextRaw = $(".min_free_values").attr("data-varlu");
    var shippingTextGiftRaw = $(".min_free_valuesforfreegift").attr(
      "data-varlu"
    );

    var shippingtext = Number(shippingTextRaw);
    var shippingtextgift = Number(shippingTextGiftRaw);

    if (!shippingTextRaw || isNaN(shippingtext)) {
      console.warn(
        "[cart] .min_free_values[data-varlu] missing or invalid — " +
          "shipping progress bar cannot compute correctly on this viewport.",
        shippingTextRaw
      );
      shippingtext = 0;
    }
    if (!shippingTextGiftRaw || isNaN(shippingtextgift)) {
      console.warn(
        "[cart] .min_free_valuesforfreegift[data-varlu] missing or invalid — " +
          "free-gift progress bar cannot compute correctly on this viewport.",
        shippingTextGiftRaw
      );
      shippingtextgift = 0;
    }

    var min_texts = $(".min_free_values").attr("data-text");
    var max_texts = $(".min_free_values").attr("data-maxfree");

    for (var i = 0; i < cartItems.length; i++) {
      if (cart.items[i].id == 44131436921014) {
        is_mini_tote_free_gift = true;
      }
      if (cart.items[i].id == 42123517460662) {
        is_mini_tote_free_gift_comp = true;
      }

      if (cart.items[i].variant_options[0].includes("Emerald")) {
        emerald = 1;
      }
      if (cart.items[i].handle.includes("disney-leather-sticker")) {
        sticker_qty = cart.items[i].quantity + sticker_qty;
      }
      if (cart.items[i].id == valId) {
        valInCart = true;
        valQty = cart.items[i].quantity;
      }
      if (cart.items[i].id == valId2) {
        valInCart2 = true;
        val2Qty = cart.items[i].quantity;
      }
      if (cart.items[i].id == valId3) {
        valInCart3 = true;
        val3Qty = cart.items[i].quantity;
      }
      if (cart.items[i].handle.includes("easy-apply-screen-protector-1")) {
        protector_is = cart.items[i].quantity;
        pro_var_id = cart.items[i].variant_id;
      }
      if (
        cart.items[i].product_type == "Phone Case" ||
        cart.items[i].product_type == "Card Phone Case" ||
        cart.items[i].product_type == "Sling Phone Case" ||
        cart.items[i].product_type == "Silicone Phone Case"
      ) {
        phone_case = true;
      }
      if (cart.items[i].product_title.includes("Day Card")) {
        card_qty = card_qty + cart.items[i].quantity;
        card_qty_id = cart.items[i].variant_id;
      }
      if (cart.items[i].product_title.includes("Phone")) {
        phone_cases_qty = phone_cases_qty + cart.items[i].quantity;
      }

      var line_count = i + 1;
      var cart_item = cartItems[i];
      var properties = cart_item.properties;
      var image = cart_item.featured_image.url;
      var title = cart_item.product_title;
      var price = cart_item.price;
      var op_price = cart_item.price;
      var variant_id = cart_item.variant_id;

      // ---- Merge lookup for this raw cart line ----
      var variantGroupKey =
        variant_id + "::" + normalizeCartItemPropertiesKey(properties);
      var variantGroup = variantLineGroups[variantGroupKey];
      var isDuplicateVariantLine = variantGroup.firstIndex !== i;

      if (isDuplicateVariantLine) {
        continue;
      }

      var quantity = variantGroup.totalQty;
      var mergedLinesAttr = variantGroup.lines
        .map(function (l) {
          return l.line + ":" + l.qty;
        })
        .join(",");

      price = Number(price) / 100;
      price = price * quantity;
      var prd_url = cart_item.url;
      var prd_type = cart_item.product_type;
      var var_title = cart_item.variant_title;
      var final_total = cart.total_price.toFixed(2) / 100;
        // Update shipping progress once per cart refresh.
        // Do this outside the item-render loop so removing/adding
        // products cannot cause multiple competing message updates.
        if (typeof updateShippingBars === "function") {
          updateShippingBars(final_total);
        }

      checkAndRemoveGift();

      if (final_total >= 300) {
        $(".cart_gift_item").find(".cart_add_btn").addClass("cartbtnvisible");
      } else {
        $(".cart_gift_item")
          .find(".cart_add_btn")
          .removeClass("cartbtnvisible");
      }

      // new progress bar mini cart (free gift threshold)
      var giftBarWidth = null;
      if (final_total < 20) {
        giftBarWidth = "15%";
      } else if (final_total >= 20 && final_total < 35) {
        giftBarWidth = "20%";
      } else if (final_total >= 35 && final_total < 40) {
        giftBarWidth = "25%";
      } else if (final_total >= 40 && final_total < 50) {
        giftBarWidth = "30%";
      } else if (final_total >= 50 && final_total < 70) {
        giftBarWidth = "35%";
      } else if (final_total >= 70 && final_total < 90) {
        giftBarWidth = "40%";
      } else if (final_total >= 90 && final_total < 100) {
        giftBarWidth = "50%";
      } else if (final_total >= 100 && final_total < 120) {
        giftBarWidth = "60%";
      } else if (final_total >= 120 && final_total < 140) {
        giftBarWidth = "70%";
      } else if (final_total >= 140 && final_total < 150) {
        giftBarWidth = "75%";
      } else if (final_total >= 150 && final_total < 160) {
        giftBarWidth = "80%";
      } else if (final_total >= 160 && final_total < 170) {
        giftBarWidth = "85%";
      } else if (final_total >= 170 && final_total < 180) {
        giftBarWidth = "90%";
      } else if (final_total >= 180 && final_total < 190) {
        giftBarWidth = "93%";
      } else if (final_total >= 190 && final_total < 199) {
        giftBarWidth = "96%";
      } else if (final_total >= 200) {
        giftBarWidth = "100%";
      }

      if (giftBarWidth !== null) {
        (function (w) {
          requestAnimationFrame(function () {
            $(".progress-bar__fillforfreegift").css("width", w);
          });
        })(giftBarWidth);
      }

      if (shippingtextgift > 0 && final_total < shippingtextgift) {
        var diff_pricefreegift = Math.round(shippingtextgift - final_total);
        $(".fullprogressbarfreegift").addClass("hide");
        $(".customprogressbarfreegift").removeClass("hide");
        $(".dyn_priceforgift").html(diff_pricefreegift);
        if (!$(".free_gift_product_aus").hasClass("disabled")) {
          $(".free_gift_product_aus").addClass("disabled");
        }
        if (is_mini_tote_free_gift) {
          $.post(
            "/cart/change.js",
            { quantity: 0, id: 44131436921014, properties: "" },
            function (item) {
              updateCart();
            },
            "json"
          );
        }
        if (is_mini_tote_free_gift_comp) {
          $.post(
            "/cart/change.js",
            { quantity: 0, id: 42261301756086, properties: "" },
            function (item) {
              updateCart();
            },
            "json"
          );
        }
      } else {
        $(".fullprogressbarfreegift").removeClass("hide");
        $(".customprogressbarfreegift").addClass("hide");
        $(".free_gift_product_aus").removeClass("disabled");
      }

      var variant_title_new = "";
      if (var_title != null) {
        var variant_title_new = var_title;
      }
      var SplitTitle = title.split("-");
      var ColNAme = typeof SplitTitle[1] !== "undefined" ? SplitTitle[1] : "";

      var ctaMessage = cart.items[i].properties
        ? cart.items[i].properties["CTA Message"] || ""
        : "";

      var cart_item_div_new =
        "<div class='item-cart-fill-main0 cart_items_div kp-" +
        variant_id +
        "' data-id=" +
        variant_id +
        " data-type='" +
        prd_type +
        "' data-value='" +
        var_title +
        "'>";
      cart_item_div_new +=
        "<div class='cart_popup_bg hide'><img src='https://cdn.shopify.com/s/files/1/0277/2212/1295/files/Loading_Hero_v2_Black_80868dd2-108e-4818-97a1-287f884976cd.gif?v=1765514843' alt='Loading...' class='icon icon-spinner'></div>";

      var iphone17Class = cart.items[i].product_title.includes("iPhone 17")
        ? "iphone-17 "
        : "";

      if (
        cart.items[i].product_type == "Screen Protector" ||
        cart.items[i].product_type == "Gift Cards" ||
        cart.items[i].product_type == "Leather Protector" ||
        cart.items[i].product_type == "newfreegift"
      ) {
        cart_item_div_new +=
          "<div class='cart-fill-product-image'><a class='cart-image'><img loading='lazy' fetchpriority='low' src='" +
          image +
          "' alt='" +
          title +
          "'> </a>";
      } else {
        cart_item_div_new +=
          "<div class='cart-fill-product-image'><a class='cart-image' href='" +
          prd_url +
          "'><img loading='lazy' fetchpriority='low'  src='" +
          image +
          "' alt='" +
          title +
          "'> </a>";
      }

      var pro_color = "";
      if (
        properties !== null &&
        properties["Text"] != null &&
        properties["Text"] != ""
      ) {
        if (properties["Foil Colour"]) pro_color = properties["Foil Colour"];
        if (properties["Foil Color"]) pro_color = properties["Foil Color"];
        cart_item_div_new +=
          "<div class ='cart-engrave engrave chess_text " +
          iphone17Class +
          pro_color +
          " " +
          prd_type.replace(/\s+/g, "-").toLowerCase() +
          "'>" +
          properties["Text"] +
          "</div>";
      }
      if (
        properties !== null &&
        properties["Phrase"] != null &&
        properties["Phrase"] != ""
      ) {
        if (properties["Foil Colour"]) pro_color = properties["Foil Colour"];
        if (properties["Foil Color"]) pro_color = properties["Foil Color"];
        cart_item_div_new +=
          "<div class ='cart-engrave engrave chess_text curated_engrave_text " +
          pro_color +
          " " +
          prd_type.replace(/\s+/g, "-").toLowerCase() +
          "'>" +
          properties["Phrase"] +
          "</div>";
      }
      cart_item_div_new +=
        "</div><div class='cart-fill-product-detail'><div class='cart-fill-detail-01'>";

      if (
        cart.items[i].product_type == "Screen Protector" ||
        cart.items[i].product_type == "Gift Cards" ||
        cart.items[i].product_type == "newfreegift"
      ) {
        cart_item_div_new +=
          "<a><p>" +
          SplitTitle[0] +
          "</p></a><span class='ajaxcart__product-meta minishoppergift'>" +
          ColNAme +
          "</span>";
      } else if (
        cart.items[i].product_type == "Cropped Wool Jacket" ||
        cart.items[i].product_type == "Wide-Leg Wool Pant"
      ) {
        cart_item_div_new +=
          "<a><p>" +
          SplitTitle[0] +
          "</p></a><span class='ajaxcart__product-meta minishoppergift'>" +
          ColNAme +
          "</span><span class='ajaxcart__product-meta size_variant_name'>" +
          var_title +
          "</span>";
      } else {
        cart_item_div_new +=
          "<a href='" +
          prd_url +
          "'><p>" +
          SplitTitle[0] +
          "</p></a><span class='ajaxcart__product-meta minishoppergift'>" +
          ColNAme +
          "</span>";
        if (ctaMessage) {
          cart_item_div_new +=
            "<div class='cart-item-cta'>" + ctaMessage + "</div>";
        }
      }
      if (variant_title_new == "Gift") {
        cart_item_div_new +=
          "<span class='ajaxcart__product-meta'>" +
          "Limited Time Only | Valued at $69" +
          "</span>";
      }
      cart_item_div_new +=
        "<div class='delate-cart-item'><button class='grey-5 header-cart-item__remove__btn cart_remove_item remove_cart_item' data-phandle=" +
        cart_item.handle +
        " data-line=" +
        line_count +
        " data-lines='" +
        mergedLinesAttr +
        "'" +
        ">";
      cart_item_div_new += "Remove</button></div>";
      cart_item_div_new += "</div><div class='cart-fill=discription'></div>";

      if (properties != null && properties["Preorder"] != "") {
        if (properties["curated text"]) {
          cart_item_div_new +=
            "<div class='cart__props'><div class='cart__prop cart_text'><span class='cartcta_text'>" +
            properties["Phrase"] +
            "</span></div></div>";
        }
      }
      if (properties != null && properties["Preorder"] != "") {
        if (properties["Preorder"]) {
          cart_item_div_new +=
            "<div class='cart__props'><div class='cart__prop cart_text'><span class='cartcta_text'>" +
            properties["Preorder"] +
            "</span></div></div>";
        }
      }

      var pro_color_new = "";
      if (
        properties !== null &&
        properties["Text"] != null &&
        properties["Text"] != ""
      ) {
        if (properties["Foil Colour"]) pro_color_new = properties["Foil Colour"];
        if (properties["Foil Color"]) pro_color_new = properties["Foil Color"];
        cart_item_div_new +=
          "<div class='cart__props'><div class='cart__prop cart_text'><span>Personalisation:</span><span class='foil-option prsnlizer_color " +
          pro_color_new +
          "' ddts='" +
          pro_color_new +
          "' style='order: 3;'></span><span class='chess_text'>" +
          properties["Text"] +
          "</span></div></div>";
      }
      if (
        properties !== null &&
        properties["Phrase"] != null &&
        properties["Phrase"] != ""
      ) {
        if (properties["Foil Colour"]) pro_color_new = properties["Foil Colour"];
        if (properties["Foil Color"]) pro_color_new = properties["Foil Color"];
        cart_item_div_new +=
          "<div class='cart__props'><div class='cart__prop cart_text curated_text'><span>Personalisation:</span><span class='foil-option prsnlizer_color " +
          pro_color_new +
          "' ddts='" +
          pro_color_new +
          "' style='order: 3;'></span><span class='chess_text'>" +
          properties["Phrase"] +
          "</span></div></div>";
      }

      if (variant_title_new == "Gift") {
        cart_item_div_new +=
          "<span class='freetext_meta'>" + "Free" + "</span>";
      }
      if (variant_title_new == "Gift") {
        cart_item_div_new += "<div class='wc_qty_box quantity-box'>";
        cart_item_div_new += "<ul class='QuantityBox cart_p_quantity'><li class=''>";
        cart_item_div_new += "</li></ul></div>";
      } else if (cart.items[i].product_type == "newfreegift") {
        cart_item_div_new += "<div class='wc_qty_box quantity-box'>";
        cart_item_div_new += "<ul class='QuantityBox cart_p_quantity'><li class=''>";
        cart_item_div_new += "</li></ul></div>";
      } else {
        cart_item_div_new +=
          "<div class='wc_qty_box quantity-box'><div class='num-block skin-3'>";
        cart_item_div_new += "<ul class='QuantityBox cart_p_quantity'><li class='minus-box'>";
        cart_item_div_new +=
          "<a href='javascript:void(0)' data-line=" +
          line_count +
          " data-lines='" +
          mergedLinesAttr +
          "' class='cart_item_minus minus ajaxcart__qty-adjust cart-slider-decrease-qty ajaxcart__qty--minus'>";
        cart_item_div_new +=
          "<img src='//cdn.shopify.com/s/files/1/0619/2575/3081/t/5/assets/minu.svg?v=419654119375667803' class='img-fluid'></a>";
        cart_item_div_new += "</li><li class='input-box'>";
        cart_item_div_new +=
          "<input readonly type='number' name='updates' class='QuantityInput Quantity_cart_slider ajaxcart__qty-num' value=" +
          quantity +
          " min='0'>";
        cart_item_div_new +=
          "</li><li class='plus-box'><a data-line=" +
          line_count +
          " data-lines='" +
          mergedLinesAttr +
          "' href='javascript:void(0)' variant_id=" +
          variant_id +
          " class='cart_item_plus plus ajaxcart__qty-adjust cart-slider-increase-qty ajaxcart__qty--plus'>";
        cart_item_div_new +=
          "<img src='//cdn.shopify.com/s/files/1/0619/2575/3081/t/5/assets/plus.svg?v=14305593096000451169' class='img-fluid'></a>";
        cart_item_div_new += "</li></ul></div></div>";
      }

      cart_item_div_new += "<div class='price'>";

      // ============================================================
      // FIX #4: replaced blocking `async: false` XHR with a proper
      // `await`ed request. iOS Safari throttles/kills synchronous XHR
      // far more aggressively than desktop browsers (especially when
      // the tab is backgrounded even briefly, e.g. switching apps to
      // check a code or address). A stalled sync request here used to
      // freeze this entire loop iteration with no visible error,
      // which could leave later DOM writes (including the shipping
      // progress bar) never applied on that render pass.
      // ============================================================
      try {
        var variantData = productJsonMap[cart_item.url];

        if (variantData && variantData.product) {
          var varinats = variantData.product.variants;

          varinats.forEach(function (variant) {
            if (parseInt(variant.id) == parseInt(variant_id)) {
              var variantprice = variant.price;
              var splitprice = variantprice.split(".");

              var nozerodecimal =
                splitprice[1] == 00
                  ? Math.trunc(variantprice)
                  : variantprice;

              var compareprice = Math.trunc(variant.compare_at_price);

              var price_discount = variantprice / compareprice;
              var percent_off = 1 - price_discount;

              sale_text = Math.round(percent_off * 100) + "% OFF";

              var currencySymbolInner = window.mdsCurrency?.symbol || window.sgcr_localization?.country?.currency?.symbol || "$";
              if (variant_title_new != "Gift") {
                if (
                  parseInt(variant.compare_at_price) >
                  parseInt(variant.price)
                ) {
                  cart_item_div_new +=
                    "<span class='regular_price price-item--sale'>" +
                    currencySymbolInner +
                    nozerodecimal +
                    " </span>";

                  cart_item_div_new +=
                    "<span class='compare_oldprice'>" +
                    currencySymbolInner +
                    compareprice +
                    " </span>";

                  cart_item_div_new +=
                    "<span class='salestext_price' hidden>" +
                    sale_text +
                    " </span>";
                } else if (
                  cart.items[i].product_type == "newfreegift"
                ) {
                  cart_item_div_new +=
                    "<span class='regular_price'> Free </span>";
                } else {
                  cart_item_div_new +=
                    "<span class='regular_price'>" +
                    currencySymbolInner +
                    nozerodecimal +
                    " </span>";
                }
              }
            }
          });
        }
      } catch (err) {
        console.warn(
          "[cart] variant price lookup failed for line " +
            line_count,
          err
        );
      }

      cart_item_div_new += "</div>";
      cart_item_div_new += "</div></div>";
      newCartHtml += cart_item_div_new;

      if (is_mini_tote_free_gift) {
        $(".c_free_gift_box").hide();
      } else {
        $(".c_free_gift_box").show();
      }
    }

    // ------------------------------------------------------------
    // Paint the completed cart in ONE DOM operation.
    //
    // This prevents existing items from disappearing and then
    // coming back one-by-one.
    // ------------------------------------------------------------
    $cartContainer.html(newCartHtml);

    $(".full_cart_loader").removeClass("active");

    // Remove only completed add placeholders.
    // The real cart rows are now present.
    $("#mds-pending-slots").empty();

    // Keep Little Luxuries state in sync after the final DOM paint.
    if (window.mdsUpsellSync) {
      window.mdsUpsellSync();
    }

    if (protector_is > 0 && phone_case == false) {
      $.post(
        "/cart/change.js",
        { quantity: 0, id: pro_var_id, properties: "" },
        function (item) {
          updateCart();
        },
        "json"
      );
    }
    if (sticker_qty != 0 && cart.item_count == sticker_qty) {
      $.post(
        "/cart/clear.js",
        function (cart) {
          updateCart();
        },
        "json"
      );
    }
    if (card_qty > 0 && phone_case == false) {
      $.post(
        "/cart/change.js",
        { quantity: 0, id: card_qty_id, properties: "" },
        function (item) {
          updateCart();
        },
        "json"
      );
    }
    if (card_qty > phone_cases_qty && phone_case) {
      $.post(
        "/cart/change.js",
        { quantity: phone_cases_qty, id: card_qty_id, properties: "" },
        function (item) {
          updateCart();
        },
        "json"
      );
    }
  });
}
window.updateCart = updateCart;

  $(".color-option span").hover(function () {
    let colorClicked = $(this).attr("class");
    let vid = $(this).attr("id");
    let vurl = $(this).attr("v-url");
    $(
      '.card-wrapper[p-id="' +
        vid +
        '"] .card-information__wrapper .card-information__text a'
    ).attr("href", vurl);
  });


  if ($("body").hasClass("pys_product")) {
    var id = $(".product_selected_id").val();
    var title = $(".product_selected_title").val();
    var myInterval = setInterval(function () {
      var len = $(".relate_product_pys li").length;
      if (len > 0) {
        clearInterval(myInterval);
        $(".related_image_pys").each(function () {
          var img_src = $(this)
            .find('.related_pys_img[data-alt="' + title + '"]')
            .attr("data-src");
          var src_len = $(this).find(
            '.related_pys_img[data-alt="' + title + '"]'
          );
          if (src_len.length > 0) {
            $(this)
              .closest(".relate_product_grid_pys")
              .find(".related_media_pys img")
              .attr("srcset", img_src);
          } else {
            var img_default_src = $(this)
              .find('.related_pys_img[data-alt="black-caviar"]')
              .attr("data-src");
            $(this)
              .closest(".relate_product_grid_pys")
              .find(".related_media_pys img")
              .attr("srcset", img_default_src);
          }
        });
      }
    }, 1000);
  }
});